<template>
  <q-list
    v-if="order.deliveryType !== DELIVERY_TYPE_OPTIONS.DIRECT_TO_CUSTOMER && order.deliveryType !== DELIVERY_TYPE_OPTIONS.VIRTUAL"
    bordered
    separator
    :class="$register ? undefined : 'bg-responsive q-mt-sm'"
    data-test-id="delivery-information-list"
    @click="showOrderOptions = true"
  >
    <slot name="header" />
    <q-item
      v-if="!$register"
      class="bg-responsive-grey-3"
    >
      <q-item-section avatar>
        <q-avatar
          icon="fal fa-popcorn"
          text-color="responsive"
        />
      </q-item-section>
      <slot name="title" />

      <q-item-section
        side
      >
        <q-item-label
          caption
          class="cursor-pointer"
        >
          {{ $t('actions.edit') }}
        </q-item-label>
      </q-item-section>
    </q-item>
    <q-item
      class="cursor-pointer"
    >
      <q-item-section>
        <q-item-label
          overline
          class="text-uppercase text-weight-bolder"
        >
          {{ $_.startCase(order.deliveryTypeName) }}
        </q-item-label>
      </q-item-section>
      <q-item-section v-if="$_.includes(DELIVERY_TYPE_OPTIONS.DELIVERY_LOCATION_REQUIRED, order.deliveryType)">
        <q-item-label
          overline
          class="text-center"
        >
          {{ order.deliveryLocation }}
        </q-item-label>
      </q-item-section>
      <q-item-section v-if="order.customDeliveryType && order.deliveryDetails">
        <q-item-label
          overline
          class="text-center ellipsis"
          style="max-width: 200px;"
        >
          {{ order.deliveryDetails }}
        </q-item-label>
      </q-item-section>
      <q-item-section v-if="order.pagerNumber">
        <q-item-label
          v-if="order.pagerNumber"
          overline
          class="text-center"
        >
          Pager #{{ order.pagerNumber }}
        </q-item-label>
      </q-item-section>
      <q-item-section v-if="order.nameForOrder">
        <q-item-label
          v-if="order.nameForOrder"
          overline
          class="text-center"
        >
          {{ order.nameForOrder }}
        </q-item-label>
      </q-item-section>
      <q-item-section
        class="text-right"
      >
        {{ order.hasDueTime ? order.formattedDueTime : 'ASAP' }}
      </q-item-section>
    </q-item>
    <order-options-dialog
      v-model="showOrderOptions"
      :order="order"
      show-timing
      :order-can-transfer-tab="order.canTransferTab"
      @update:model-value="value => showOrderOptions = value"
    />
  </q-list>
</template>

<script>
import { DELIVERY_TYPE_OPTIONS } from 'src/models/delivery-type/DeliveryType'
import OrderOptionsDialog from 'src/modules/register/dialogs/OrderOptionsDialog'
export default {
  name: 'DeliveryInformationList',
  components: {
    OrderOptionsDialog
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showOrderOptions: false
    }
  },
  created () {
    _.extend(this, { DELIVERY_TYPE_OPTIONS })
  }
}

</script>
